import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';

@Api('api/app/user-feedback')
export class UserFeedbackDto extends DtoHasApi {
  content: string;
  pageUrl?: string;
  environment?: string;
  pageTitle?: string;
}